export const environmentInfo = [
  // 'env_template', // this has been moved to pageInfo
  'env_work',
  'env_market',
  'env_language',
  'env_site_type',
  'env_brand_code',
  'env_brand',
  'env_currency_code',
  'feature_context_id',
  'in_usabilla_button_active',
  'in_usabilla_exit_var',
  'in_dapiSessionId',
  'visit_id',
  'edo_browser_id',
  'ext_ga_client_id',
  'didomiVendorsConsentDenied',
  'of_version',
  'home_version',
] as const;

export const testDimensions = [
  'in_test_dimensionsFC',
  'in_test_dimensionsFI',
  'in_test_dimensionsFR',
  'in_test_dimensionsOF',
  'in_test_dimensionsPL',
  'in_test_dimensionsPR',
  'in_test_dimensionsUX',
  'in_test_dimensionsX1',
  'in_test_dimensionsX2',
] as const;

/**
 * Marketing info search
 * these are NOT considered as global properties
 */
export const marketingSearchInfo = [
  'mkt_utm_campaign_search',
  'mkt_utm_source_search',
  'mkt_utm_medium_search',
  'mkt_utm_content_search',
  'mkt_utm_term_search',
] as const;

/**
 * Marketing info cookie
 * these are considered as global properties
 */
export const marketingCookieInfo = [
  'mkt_utm_campaign_cookie',
  'mkt_utm_source_cookie',
  'mkt_utm_medium_cookie',
  'mkt_utm_content_cookie',
  'mkt_utm_term_cookie',
  'mkt_portal',
  'ext_tduid',
] as const;

export const marketingInfo = [
  ...marketingSearchInfo,
  ...marketingCookieInfo,
] as const;

export const passengersInfo = [
  'customer_address',
  'customer_bookings_per_user',
  'customer_city',
  'customer_country',
  'customer_email', // TODO: Remove this when PEX-1251 is validated
  'customer_email_hash',
  'customer_name',
  'customer_surname',
  'customer_telephone',
  'customer_postal_code',
  'pax_birthday',
  'pax_document_country',
  'pax_document_expiry',
  'pax_document_number',
  'pax_document_type',
  'pax_gender',
  'pax_name',
  'pax_surname',
  'pax_loyalty_card',
  'pax_country_code',
  'pax_title',
  'pax_category',
] as const;

export const userInfo = [
  'user_sso_login',
  'user_prime_bookings',
  'user_prime_eligibility',
  'user_prime_member',
  'user_prime_subscription',
  'user_prime_subscription_type',
  'registered_user_id',
] as const;

export const datalayerGlobal: string[] = [
  ...environmentInfo,
  ...testDimensions,
  ...marketingCookieInfo,
  ...passengersInfo,
  ...userInfo,
];
